import { IS_DISABLED } from '../actionTypes';
import { alertsActions } from '../reducer';

export default (isDisabled) => alertsActions[IS_DISABLED](isDisabled);
